import { APIService } from '@/api/APIService.js'
import { validators } from '@/validators/index'

const drillDown = function (section, path) {
  const p = path.shift()
  if (Object.prototype.hasOwnProperty.call(section, p)) {
    if (path.length === 0) {
      return section[p]
    }
    return drillDown(section[p], path)
  }
  return ''
}

export default {
  namespaced: true,
  state: {
    portal: {}
  },
  actions: {
    async fetchUiStrings ({ commit, state }, language) {
      const apiService = new APIService()
      try {
        const portalResult = await apiService.fetchPortalStrings(language.toUpperCase())
        const generalResult = await apiService.fetchGeneralStrings(language.toUpperCase())
        if (portalResult.status === 200 && generalResult.status === 200) {
          commit('INITIALIZE_STRINGS', { portalStrings: portalResult.data, generalStrings: generalResult.data })
          validators.forEach(vld => {
            vld.message = state.portal.validatorMessages[vld.message]
          })
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  mutations: {
    INITIALIZE_STRINGS (state, payload) {
      state.portal = payload.portalStrings.sections
      state.general = payload.generalStrings.sections
    }
  },
  getters: {
    getUiString: state => path => {
      return Array.isArray(path)
        ? drillDown(state.portal, path)
        : `paramerror: ${path}`
    },
    checklistTypes: state => {
      return Object.keys(state.portal.document_types).map(t => {
        return { key: t, text: state.portal.document_types[t] }
      })
    },
    receiptDescriptions: state => {
      return Object.keys(state.general.dropzone_strings.receipt_description_list).map(d => {
        return { key: d, text: state.general.dropzone_strings.receipt_description_list[d] }
      })
    },
    validatorMessage: state => key => {
      return state.validatorMessages(key) || ''
    },
    getDropzoneStrings: state => {
      return state.general.dropzone_strings
    },
    getPopupStrings: state => {
      return state.general.popup_strings
    }
  }
}
